import React from 'react';
import { Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useStyles from './ScoreInfo.styles';

const ScoreInfoSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.skeletonContainer}>
      <Skeleton height={140} width="80%" className={classes.skeleton} />
    </Paper>
  );
};

export default ScoreInfoSkeleton;
